import React from "react";
import { v4 as uuid4 } from "uuid";
import { EducationItem } from "./styledComponents";

const educationDetailsList = [
  {
    id: uuid4(),
    institue: "Nxtwave Disruptive Technologies",
    degAndSector: "Industry Ready Certification in Full-stack Development",
    duration: "Oct 2022 - Ongoing",
  },
  {
    id: uuid4(),
    institue:
      "Siddhartha institute of engineering & technology Ibrahimpatnam",
    degAndSector:
      "B Tech (Bachelor of Technology)-Electrical & Electronics Engineering (EEE) (7.38 CGPA)",
    duration: "2020 - 2023",
  },
  {
    id: uuid4(),
    institue: "Ramananda thirtha engineering collage Nalgonda",
    degAndSector: "Diploma-EEE (77.95%)",
    duration: "2017 - 2020",
  },
  {
    id: uuid4(),
    institue: "Z P High School, Chittaloor,Nalgonda",
    degAndSector: "Secondary School Of Certificate (8.5 CGPA)",
    duration: "2016- 2017",
  },
];

const educationItem = (educationDetails) => {
  const { id, institue, degAndSector, duration } = educationDetails;
  return (
    <EducationItem key={id}>
      <p>
        <strong>{duration}</strong>
      </p>
      <h3>{institue}</h3>
      <p>{degAndSector}</p>
    </EducationItem>
  );
};

const Education = () => {
  return (
    <article>
      <ul>{educationDetailsList.map((eachItem) => educationItem(eachItem))}</ul>
    </article>
  );
};

export default Education;
